import { useCallback } from 'react';

import { Button } from '@twilio-paste/core/button';

import { AppsTable } from '../../components/Apps/AppsTable';
import { AppsTableContextProvider } from '../../components/Apps/AppsTable/AppsTableContext';
import { Can } from '../../components/common/AbilityContext';
import { useDrawer } from '../../components/common/Drawer';
import { PageComponent } from '../../components/common/PageComponent';
import { Action, Subject } from '../../modules/Permissions';

export function AppsPage() {
  const createAppDrawerState = useDrawer();
  const editAppDrawerState = useDrawer();
  const viewAppDrawerState = useDrawer();
  const openDrawer = useCallback(() => createAppDrawerState.show(), [createAppDrawerState]);

  return (
    <PageComponent
      pageTitle="Apps"
      actions={
        <Can I={Action.Create} a={Subject.App}>
          <Button variant="primary" onClick={openDrawer}>
            New App
          </Button>
        </Can>
      }
    >
      <AppsTableContextProvider
        createAppDrawerState={createAppDrawerState}
        editAppDrawerState={editAppDrawerState}
        viewAppDrawerState={viewAppDrawerState}
      >
        <AppsTable />
      </AppsTableContextProvider>
    </PageComponent>
  );
}
